import axios from 'axios';
import { useMutation } from 'react-query';
import Cookies from 'js-cookie';
import { useQueryPersonalBills } from '../Dashboard/useQueryPersonalBills';
import { useSnackbar } from 'hooks/UseSnackbar';
import { useTranslation } from 'react-i18next';
import { sendEmails } from 'services/Emails/Quota/quotaEmailService';

export const useMutationAddBill = (setOpen, id) => {
    const toast = useSnackbar();
    const [t] = useTranslation();

    const queryPersonalBills = useQueryPersonalBills({ enabled: false }, id);

    const mutation = useMutation({
        mutationFn: async obj =>
            await axios.put(
                process.env.REACT_APP_SERVER +
                    `api/Quota/Bills/User/${obj.get('id')}/GenerateOrReopen`,
                obj,
                {
                    headers: {
                        'Content-type': 'application/json',
                        Authorization:
                            'bearer ' +
                            (Cookies.get('auth-token')
                                ? Cookies.get('auth-token')
                                : '')
                    }
                }
            ),
        onSuccess: res => {
            toast.success(t('QUOTAS.billAddedSuccess'));
            sendEmails(res.data, 'api/Quota/Bills/Generate');
        },
        onError: err => {
            if (err.response.data.message && err.response.data.code !== 1000) {
                toast.error(err.response.data.message);
            } else {
                toast.error(t('QUOTAS.billAddedError'));
            }
        },
        onSettled: () => {
            setOpen(false);
            queryPersonalBills.refetch();
        }
    });

    return mutation;
};
